module.exports = __webpack_public_path__ + "img/adaptability.d2f2b371.png";